import { render, staticRenderFns } from "./TravelNotesDetail.vue?vue&type=template&id=4c8ff026&scoped=true"
import script from "./TravelNotesDetail.vue?vue&type=script&lang=js"
export * from "./TravelNotesDetail.vue?vue&type=script&lang=js"
import style0 from "./TravelNotesDetail.vue?vue&type=style&index=0&id=4c8ff026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ff026",
  null
  
)

export default component.exports